// @flow

import React from "react";

import Label from "./Label";
import Title from "./Title";

const Film = ({film}): React$Element<div> => {
  return(
    <div className="l-col-4-l l-col-6-m l-col-12-s">
      <a href={`/kinderfilms/${film.slug}`} className="card card--wide flex-column">
        <div className="position-relative">
          <div className="scaling-image">
            <div className="card__progress-bar" data-behavior="video-progress" data-mid={film.mid}></div>
            <div className="scaling-image__inner">
              <img src={film.thumbnail} alt={film.title} />
            </div>
          </div>
        </div>
        <div className="position-absolute margin-top-3 min-w-90 text-center">
          <Label label={film.label} />
        </div>
        <div className="position-absolute bottom padding-2 flex-initial w-full">
          <div className="bg-black text-white padding-x-2 font-xs margin-bottom-xs inline-block line-height-sm">
            {film.length} min
          </div>
          <div className="flex self-center flex-1 min-w-0">
            <Title title={film.title} />
          </div>
        </div>
      </a>
    </div>
  )
}

export default Film;
